<template>
    <div style="margin-bottom:20px;">
        <div class="bbt-topbar">
            <div class="bbt-container bbt-clearfix">
                <div class="bbt-topbar__data">
                </div>
                <ul class="bbt-topbar__menu bbt-clearfix">
                    <!-- <li>
                        <a href="/pages/userAction.html?t=r" class="" v-if="user.username == null">立即注册</a>
                        <router-link :to="{path:'/userDetail/' + user.userid + '/UserDetailPost'}" v-else>
                        {{user.username}}
                        </router-link>
                    </li> -->
                    <li>
                        <a href="javascript:;" @click="loginIn" class="" v-if="user.username == null">登录</a>
                        <a href="javascript:;" @click="loginOut" class="" v-else>退出</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="bbt-header">
            <div class="bbt-header__fix">
                <div class="bbt-container bbt-clearfix">
                    <div class="bbt-header__logo">
                        <a href="/"><img src="../assets/logo_head2.png" height="32px"></a>
                    </div>
                    <div class="bbt-header__main" lay-filter="head">
                        <ul class="bbt-header__nav bbt-clearfix">
                            <li @mouseenter="subNavShow" @mouseleave="subNavHide" v-for="item in headLinks" v-bind:key="item.value">
                                <router-link :to="{path:'/more_article'}" v-if="item.label == '快讯' && item.dictVoList.length == 0">
                                    {{item.label}}
                                    <i v-if="item.dictVoList.length"></i>
                                </router-link>
                                
                                <router-link v-else-if="item.label == '快讯' && item.dictVoList.length">
                                    {{item.label}}
                                    <i v-if="item.dictVoList.length"></i>
                                </router-link>

                                <router-link :to="item.value" v-else>
                                    {{item.label}}
                                    <i v-if="item.dictVoList.length"></i>
                                </router-link>

                                <div class="sub__nav" style="display: none;" v-if="item.dictVoList.length">
                                    <dl style="margin:0;">
                                        <dd v-for="d in item.dictVoList" v-bind:key="d.value">
                                            <router-link :to="{path:'/newsIndex/' + d.value}" v-if="item.label == '资讯'">
                                                {{d.label}}
                                            </router-link>

                                            <!-- <router-link :to="{path:'/postIndex/' + d.value}" v-if="item.label == '社区'">
                                                {{d.label}}
                                            </router-link> -->
                                        </dd>
                                    </dl>
                                </div>
                            </li>
                        </ul>
                        <div class="bbt-header__control">
                            <div class="bbt-header__search">
                                <form action="">
                                    <input type="text" placeholder="搜索..." v-model.trim="searchText" class="bbt-header__input">
                                    <i class="el-icon-search" @click.enter="searchResult"></i>
                                </form>
                            </div>
                            <!-- <div class="bbt-header__apply">
                                <a href="/userAction.html" target="_blank">
                                    <i class="el-icon-edit" style="font-size:20px;position:relative;top:3px;margin-right:2px;"></i>
                                    开通海盗号
                                </a>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { getHomeMenu } from '@/api/api'
    export default {
        name:'HeadIndex',
        data(){
            return {
                searchText:'',
                headLinks:[],
                user:{}
            }
        },
        props:{
            serveHost: String
        },
        watch:{
            
        },
        methods:{
            subNavShow:function(events) {
                $(events.target).children('.sub__nav').fadeIn(.3);
            },
            subNavHide:function(events) {
                $(events.target).children('.sub__nav').fadeOut(.3);
            },
            searchResult:function() {
                const search_text = this.searchText;
                this.$router.push({name:'search', params: {search_text}});
                this.searchText = '';
            },
            loginOut:function() {
                this.$confirm('是否注销登录？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(()=>{
                    localStorage.removeItem('user');
                    localStorage.removeItem('token');
                    this.user = {};
                    location.href = '/';
                }).catch(()=>{

                });
            },
            loginIn:function() {
                location.href = '/pages/userAction.html?t=l';
            }
        },
        created(){
            this.user = localStorage.user? JSON.parse(localStorage.user) : this.user;
        },
        mounted:function(){
            getHomeMenu({}).then((res) => {
                this.headLinks = res.data.data;
            });
        }
    }
</script>

<style scoped>
.bbt-topbar__data>span>span, .bbt-topbar__data a {
    color: #fff;
}
.limit-height {
    overflow: hidden;
    vertical-align: bottom;
    height: 20px;
    display: inline-block;
}
.bbt-topbar__data>span {
    margin-right: 16px;
}
.bbt-topbar__menu li .share-pop:after {
    content: "";
    position: absolute;
    left: 50%;
    margin-left: -6px;
    top: -12px;
    width: 0;
    height: 0;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent #fff;
}
.bbt-topbar__menu li .share-pop {
    display: none;
    position: absolute;
    z-index: 100;
    padding: 2px;
    left: 50%;
    transform: translateX(-52%);
    top: 28px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 4px 5px 0 rgba(0,0,0,.06), 0 1px 10px 0 rgba(0,0,0,.04), 0 0 4px -1px rgba(0,0,0,.08);
}
.bbt-topbar__menu li i {
    font-size: 12px;
    line-height: 20px;
    margin-right: 4px;
}
.bbt-topbar__menu li+li:before {
    content: "";
    position: absolute;
    top: 6px;
    left: 0;
    width: 1px;
    height: 8px;
    background: #fff;
    opacity: .4;
}
.bbt-topbar__menu li>a {
    color: hsla(0,0%,100%,.64);
    display: inline-block;
    position: relative;
    transition: all .3s ease;
}
.bbt-topbar__menu li {
    position: relative;
    padding: 0 16px;
    list-style: none;
    float: left;
}
.bbt-topbar__menu {
    float: right;
    padding-left: 0;
    margin: 0 auto;
    color: hsla(0,0%,100%,.64);
}
.bbt-topbar__data {
    float: left;
    width: 600px;
    color: hsla(0,0%,100%,.64);
}
.bbt-topbar {
    background: #1e1e1e;
    font-size: 12px;
    line-height: 20px;
    padding: 6px 0;
    z-index: 100;
}

.bbt-header {
    position: relative;
    z-index: 99;
    width: 100%;
    height: 56px;
}
.bbt-header__fix {
    width: 100%;
    min-width: 1200px;
    height: 56px;
    background: #fff;
    box-shadow: 0 4px 5px 0 rgba(0,0,0,.06), 0 1px 10px 0 rgba(0,0,0,.04), 0 0 4px -1px rgba(0,0,0,.08);
    transition: all .3s ease;
}
@media (min-width: 1200px) {
    .bbt-container {
        width: 1200px;
    }
}
.bbt-container {
    padding-left: 12px;
    padding-right: 12px;
    margin: 0 auto;
}
.bbt-container:after {
    clear: both;
}
.bbt-container:after, .bbt-container:before {
    display: table;
    content: "";
}
.bbt-header__logo {
    float: left;
    height: 28px;
    margin: 12px 0;
}
.bbt-header__logo a {
    height: 32px;
    display: block;
}
.bbt-header__nav {
    float: left;
    display: inline-block;
    margin: 0 auto;
    margin-left: 16px;
    vertical-align: top;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
}
.bbt-header__nav>li {
    float: left;
    list-style: none;
    padding: 0 8px;
    position: relative;
}
.bbt-header__nav>li>a {
    padding: 16px 6px;
    display: block;
}

.link-dark-minor {
    color: rgba(0,0,0,.56);
    transition: all .3s ease;
}
.bbt-header__nav>li>a i {
    display: inline-block;
    width: 0;
    height: 0;
    border-width: 4px;
    border-style: solid;
    margin-left: 4px;
    border-color: rgba(0,0,0,.56) transparent transparent;
}
.bbt-header .sub__nav {
    position: absolute;
    left: 10px;
    top: 56px;
    min-width: 122px;
    background: #fff;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 6px 24px 2px rgba(0,0,0,.06), 0 6px 30px 5px rgba(0,0,0,.04), 0 0 10px -5px rgba(0,0,0,.08);
    overflow: hidden;
}

.bbt-header .sub__nav dd {
    height: 38px;
    line-height: 38px;
    color: rgba(0,0,0,.56);
    font-size: 14px;
    transition: all .3s ease;
}
.bbt-header .sub__nav dd a {
    display: block;
    padding: 0 24px;
    color: inherit;
    white-space: nowrap;
}
.bbt-header__nav>li>span {
    display: inline-block;
    width: 34px;
    height: 16px;
    background: #f46300;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
    border-radius: 4px;
    text-align: center;
    position: absolute;
    right: -10px;
    top: 10px;
}
.bbt-header__control {
    float: right;
    overflow: hidden;
}

.bbt-header__search {
    display: inline-block;
    position: relative;
    margin-left: 12px;
    /* margin-right: 32px; */
    margin-top:13px;
}
.bbt-header__input {
    background: #f1f1f1;
    border-radius: 100px;
    height: 32px;
    width: 200px;
    outline: none;
    border: none;
    padding: 0 16px;
    transition: all .3s ease;
}
.bbt-header__search i {
    position: absolute;
    top: 9px;
    right: 8px;
    color: gray;
}

.bbt-icon {
    line-height: 1;
    font-size: 14px;
}
.bbt-icon {
    font-family: bbt-icon!important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.bbt-header__apply {
    display: inline-block;
}
.bbt-header__apply>a {
    font-size: 14px;
    line-height: 22px;
    padding: 17px 16px;
    background: #409EFF;
    color: #fff;
    display: block;
    transition: all .3s ease;
}
.bbt-header__nav>li:hover > a, .bbt-header .sub__nav dd:hover {
    color: #409EFF;
}
.bbt-header .sub__nav dd:hover {
    color: #fff;
    background-color:#409EFF;
}

.bbt-header__nav>li:hover a i {
    border-color: #409EFF transparent transparent;
}
</style>